import { Overlay, Content } from '@radix-ui/react-dialog';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledOverlay = styled(Overlay)`
  ${tw`fixed flex flex-col w-full m-0 justify-end items-end inset-0 overflow-y-auto overflow-x-hidden bg-[linear-gradient(180deg,_var(--tw-gradient-from)_75%,_var(--tw-gradient-to)_100%)] from-slate-800/0 to-slate-800/25`}

  z-index: 1000;
`;

const ContentContainer = styled.div`
  ${tw`flex flex-col w-full justify-end items-center shadow-xl flex-1 m-auto pt-[50dvh] md:pb-8 px-4 rounded-xl`}

  z-index: 1001;
`;

const StyledContent = styled(Content)`
  ${tw`relative flex flex-col justify-start items-center sm:max-w-[calc(100dvw-8rem)] xl:max-w-[1188px] py-2 px-10 mx-6 inset-0 overflow-y-auto overflow-x-hidden bg-white/75 backdrop-blur border border-white rounded-xl`}

  z-index: 1002;
`;

const Items = styled.div`
  ${tw`gap-2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4`}
`;

const CloseButtonContainer = styled.div`
  ${tw` sm:absolute mt-2 sm:mt-0 right-0 top-1 right-1 rounded-full backdrop-blur-sm md:backdrop-blur-0 drop-shadow-sm md:drop-shadow-none flex`}
`;

const WeigthsWrapper = styled.div<{ $isActive?: boolean }>`
  ${tw`flex flex-col justify-between pl-3 pr-1 py-4 bg-white rounded-xl border`}

  ${({ $isActive }) => ($isActive ? tw`border-primary` : tw`border-slate-200`)}
`;

const BottomContainer = styled.div`
  ${tw`flex justify-center gap-2 pt-3 pb-1`}
`;

export {
  StyledOverlay,
  ContentContainer,
  StyledContent,
  Items,
  CloseButtonContainer,
  WeigthsWrapper,
  BottomContainer,
};
